import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Modal from 'components/ui/Modal';
import { bookingShape } from 'constants/propTypes';
import { INFANT_FIRST_NAME_KEY, INFANT_LAST_NAME_KEY } from 'constants/passengers';
import { getInfantsMissingUuidForTravelDocuments } from 'utils/getInfantPassengersFromDetails';

const getFullName = (firstName, lastName) => [firstName, lastName].filter(Boolean).join(' ');

const MissingInfantUuidModal = ({ booking }) => {
  const [isOpen, setIsOpen] = useState(true);
  const infantsMissingUuid = getInfantsMissingUuidForTravelDocuments({ booking });

  if (!infantsMissingUuid.length) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      title={<FormattedMessage id="bookingDetails.missingInfantUuidModal.title" />}
      subtitle={<FormattedMessage id="bookingDetails.missingInfantUuidModal.subtitle" />}
      onClose={() => setIsOpen(false)}
    >
      <p>
        <FormattedMessage id="bookingDetails.missingInfantUuidModal.body" />
      </p>
      <ul>
        {infantsMissingUuid.map((infant) => {
          const infantName = getFullName(infant[INFANT_FIRST_NAME_KEY], infant[INFANT_LAST_NAME_KEY]) || '-';
          const parentPassengerName =
            getFullName(infant.parentPassenger?.firstName, infant.parentPassenger?.lastName) || infant.passengerRef;

          return (
            <li key={infant.passengerRef}>
              <FormattedMessage id="bookingDetails.missingInfantUuidModal.infant" values={{ infantName, parentPassengerName }} />
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};

MissingInfantUuidModal.propTypes = {
  booking: bookingShape
};

export default MissingInfantUuidModal;
